import { render, staticRenderFns } from "./PlanejamentoContratoFormAcoesControlePopoverCopiaCategoria.vue?vue&type=template&id=246353ea"
import script from "./PlanejamentoContratoFormAcoesControlePopoverCopiaCategoria.vue?vue&type=script&lang=js"
export * from "./PlanejamentoContratoFormAcoesControlePopoverCopiaCategoria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports